/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignLeftIcon16Regular = forwardRef('TextAlignLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 2.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M2.25 6A.75.75 0 0 1 3 5.25h6a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 6Z" }),
        React.createElement("path", { d: "M3 8.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M3 11.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H3Z" })));
});
